import React from 'react';

import { makeIconDef } from '../../makeIconDef';

export const PrevSliderArrowIconDef = {
  'prev-slider-arrow': makeIconDef('prev-slider-arrow', {
    regular: () => <svg fill="none"><path d="M18 23L7.70711 12.7071C7.31658 12.3166 7.31658 11.6834 7.70711 11.2929L18 1" fill="none" stroke="currentColor" strokeWidth="2" /></svg>,
  })
}